<template>
  <DashboardContainer>
    <v-card>
      <v-card-title>
        Successful Payment
        <v-icon color="green" style="margin-left: 5px;">mdi-check-circle</v-icon>
      </v-card-title>
      <v-card-text>
        You successfully upgraded your plan. Go to
        <router-link to="/projects">projects</router-link>
        {{' '}}page and start crafting your website.
      </v-card-text>
    </v-card>
  </DashboardContainer>
</template>

<script>
import DashboardContainer from "../components/DashboardContainer";
export default {
  components: {
    DashboardContainer
  },
  methods: {},
  created() {
    document.title = "Success - Landly Console";
  }
};
</script>